import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { XCircle, AlertCircle, Frown, TrendingDown } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <AlertCircle className="w-6 h-6 text-rose-500" data-id="element-163" />,
    text: 'No sabés por dónde empezar para ganar dinero'
  }, {
    icon: <XCircle className="w-6 h-6 text-rose-500" data-id="element-164" />,
    text: 'Tenés miedo de equivocarte o no ser lo suficientemente buena'
  }, {
    icon: <Frown className="w-6 h-6 text-rose-500" data-id="element-165" />,
    text: 'Ves a otras personas avanzar y sentís que vos estás estancada'
  }, {
    icon: <TrendingDown className="w-6 h-6 text-rose-500" data-id="element-166" />,
    text: 'Querés generar ingresos pero no tenés muchas opciones reales'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 bg-white" data-id="element-167">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168">
        <SectionHeading title="¿Querés aprender manicura y empezar a generar ingresos desde casa pero no sabés por dónde empezar?" subtitle="Quizás te pasa que:" data-id="element-169" />

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-170">
          {problems.map((problem, index) => <motion.div key={index} variants={itemVariants} className="bg-rose-50 rounded-2xl p-6 flex items-start gap-4 border border-rose-100 shadow-sm" data-id="element-171">
              <div className="bg-white p-2 rounded-full shadow-sm shrink-0" data-id="element-172">
                {problem.icon}
              </div>
              <p className="text-dark-light font-medium pt-1" data-id="element-173">{problem.text}</p>
            </motion.div>)}
        </motion.div>

        <motion.div className="bg-dark text-white rounded-3xl p-8 md:p-10 text-center relative overflow-hidden shadow-xl" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-174">
          <div className="absolute top-0 right-0 w-32 h-32 bg-rose-500/20 rounded-full blur-2xl" data-id="element-175"></div>
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-gold-500/20 rounded-full blur-2xl" data-id="element-176"></div>

          <p className="text-xl md:text-2xl font-playfair italic mb-6 relative z-10" data-id="element-177">
            Muchas personas escuchan siempre la misma respuesta:
            <br data-id="element-178" />
            <span className="text-rose-300 font-bold" data-id="element-179">
              "No es para vos si no tenés experiencia".
            </span>
          </p>
          <p className="text-lg text-rose-100 relative z-10" data-id="element-180">
            Pero la realidad es que con la guía correcta, podés aprender desde
            cero y empezar a ganar dinero desde tu casa rápidamente.
          </p>
        </motion.div>
      </div>
    </section>;
}